import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import useCampaign from '../../hooks/use_campaign';
import useTranslation from '../../hooks/use_translation';
import BadgeContainer from '../framework/badges/badge_container';
import BadgeCampaign from '../framework/badges/badge-campaign';
import BadgeDiscount from '../framework/badges/badge-discount';
import BiomarkerAmount from '../framework/biomarker-amount';
import Clickable from '../framework/clickable';
import GroupLink from '../framework/group_link';
import PriceItem from '../shop/price_item';
import Trans from '../translation/trans';
import ProductGroupIcon from './product-group-icon';
import ProductShopButton from './product-shop-button';

const ProductItemCard = ({
	currency,
	excerpt,
	group_id,
	groups,
	markers,
	onAddToCart,
	page,
	price,
	price_discount,
	product_default,
	product_id,
	product_image,
	product_variant_id,
	slug,
	state,
	subtitle,
	title,
	tracking,
}) => {
	const { t } = useTranslation('component_test_product_list_item');
	const id_key = `product-item-${product_variant_id}-${slug}`;
	const { isActive } = useCampaign();

	return (
		<Clickable className="h-100 pb-lg-5 pb-3" id={id_key} is="div">
			<div className="card-container mb-1 product-list-item position-relative border-0 h-100">
				<BadgeContainer position="top_left">
					<BadgeDiscount
						className=""
						price={price}
						price_discount={price_discount}
					/>
				</BadgeContainer>

				{price_discount > 0 && isActive && (
					<BadgeContainer position="top_right">
						<BadgeCampaign className="" />
					</BadgeContainer>
				)}

				{product_image && (
					<>
						<GatsbyImage
							alt={title}
							className="img-fluid product-item-card-img "
							draggable="false"
							image={getImage(product_image)}
						/>
					</>
				)}
				{!product_image && (
					<div className="img-fluid product-item-card-img product-item-card-group-icon d-flex-align-items-center justify-content-center">
						<ProductGroupIcon
							alt={title}
							groups={[group_id]}
							type="product_img"
						/>
					</div>
				)}

				<div className="d-flex flex-column product-item-card-content pt-2 pb-1 position-relative">
					<div className="">
						<div className="d-flex align-items-center">
							<div>
								{subtitle && (
									<div className="list-subtitle mb-0 text-muted me-1 text-break white-space-break">
										{subtitle}
									</div>
								)}
								<h3 className="text-primary-dark mb-0 card-title text-break white-space-break">
									<GroupLink
										className="clickable text-decoration-none text-break white-space-break text-primary-dark"
										groups={
											product_default?.group_id
												? [product_default?.group_id]
												: groups
										}
										page={page}
										product_id={product_id}
									>
										{title}
									</GroupLink>
								</h3>
								<div>
									{markers.length > 0 && (
										<span className="me-1">
											<BiomarkerAmount
												count={markers.length}
												groups={groups}
												product_id={product_id}
												size="xs"
											/>
										</span>
									)}
								</div>
							</div>
						</div>

						<div className="mt-2 mt-lg-2 mb-2 justify-content-center x-small">
							<div className="list-check text-break white-space-break text-max-lines-list-fade card-list text-muted">
								<Trans defaults={excerpt} t={t} />
							</div>
						</div>
					</div>
					<div className="position-absolute bottom-0 white-fade pt-3 w-100 end-0 start-0 p-2">
						<div className="price">
							<p className="fw-500 mb-0 text-number me-2">
								<PriceItem
									currency={currency?.code}
									price={price}
									price_discount={price_discount}
								/>
							</p>
						</div>
						<div className="d-flex align-items-center justify-content-start ">
							{state != 'affiliate' && (
								<ProductShopButton
									onAddToCart={onAddToCart}
									product_id={product_id}
									tracking={tracking}
									variant="slim"
								/>
							)}
							<div className="icon-circle bg-gray-100 icon-circle-light ms-1">
								<ArrowRightShort className="h3 mb-0" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</Clickable>
	);
};

ProductItemCard.propTypes = {
	currency: PropTypes.object,
	excerpt: PropTypes.string,
	group_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	groups: PropTypes.array,
	markers: PropTypes.array,
	onAddToCart: PropTypes.func,
	page: PropTypes.string,
	price: PropTypes.string,
	price_discount: PropTypes.string,
	product_default: PropTypes.object,
	product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	product_image: PropTypes.object,
	product_variant_id: PropTypes.number,
	slug: PropTypes.string,
	state: PropTypes.string,
	status: PropTypes.string,
	subtitle: PropTypes.string,
	title: PropTypes.string,
	tracking: PropTypes.object,
};

export default ProductItemCard;
